export default __webpack_public_path__ + "static/media/Custom-HUD-04.2c4a85db.jpg";